export type ErrorProps = {
  statusCode: number;
  title: string;
  description: string;
};

export function Error({ statusCode, title, description }: ErrorProps) {
  return (
    <div className='flex min-h-screen flex-col items-center justify-center relative overflow-hidden'>
      <div className='text-center'>
        <h1 className='text-4xl font-bold'>{statusCode}</h1>
        <h2 className='mt-2 text-xl font-semibold'>{title}</h2>
        <p className='mt-2 text-muted-fg'>{description}</p>
      </div>
    </div>
  );
}
